import React, { memo, useEffect, useMemo, useRef, useState } from "react";

const videoContainerStyle = {
    width: "100%",
    maxWidth: "100%",
    maxHeight: "70vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "#000",
    borderRadius: 8,
    overflow: "hidden"
};

const videoStyle = {
    width: "100%",
    height: "100%",
    maxHeight: "70vh",
    objectFit: "contain"
};

function VideoPreview({ videoFile, existingVideoUrl }) {
    const videoRef = useRef(null);
    const [fileUrl, setFileUrl] = useState(null);

    // 1) Создаём blob-URL только при смене файла
    useEffect(() => {
        if (!videoFile) {
            setFileUrl(null);
            return;
        }

        const url = URL.createObjectURL(videoFile);
        setFileUrl(url);

        return () => URL.revokeObjectURL(url);
    }, [videoFile]);

    // 2) Стабильное вычисление src
    const src = useMemo(
        () => fileUrl || existingVideoUrl || "",
        [fileUrl, existingVideoUrl]
    );

    // 3) Меняем источник только когда он реально изменился.
    // Не используем key и не дергаем load() на каждый ререндер.
    useEffect(() => {
        const video = videoRef.current;
        if (!video) return;

        if (!src) {
            // корректно "очистить" источник
            video.removeAttribute("src");
            video.load();
            return;
        }

        // Важно: сравниваем с текущим src, чтобы не сбрасывать декодер повторно
        // (video.currentSrc может быть пустым до load, поэтому проще сравнивать video.src)
        if (video.src !== src) {
            const wasPlaying = !video.paused && !video.ended;

            video.src = src;
            video.load(); // один раз на фактическую смену источника

            if (wasPlaying) {
                video.play().catch(() => {});
            }
        }
    }, [src]);

    if (!src) return null;

    return (
        <div style={videoContainerStyle}>
            <video
                ref={videoRef}
                controls
                preload="auto"
                playsInline
                style={videoStyle}
            />
        </div>
    );
}

export default memo(VideoPreview);
